'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'face-glasses';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e377';
var svgPathData = 'M256 496C123.5 496 16 388.5 16 256c0-28.1 4.8-55 13.7-80L48 176l0 120 0 8 8 0 176 0 8 0 0-8 0-120 32 0 0 120 0 8 8 0 176 0 8 0 0-8 0-120 18.3 0c8.8 25 13.7 51.9 13.7 80c0 132.5-107.5 240-240 240zM224 176l0 112L64 288l0-112 0-16 160 0 0 16zm16-16l0-8 0-8-8 0L56 144l-8 0 0 8 0 8-12 0C73 75.2 157.6 16 256 16s183 59.2 220 144l-12 0 0-8 0-8-8 0-176 0-8 0 0 8 0 8-32 0zm48 0l160 0 0 16 0 112-160 0 0-112 0-16zM256 0C148.6 0 56.6 66.2 18.6 160L8 160l-8 0 0 16 8 0 4.7 0C4.5 201.2 0 228.1 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-27.9-4.5-54.8-12.7-80l4.7 0 8 0 0-16-8 0-10.6 0C455.4 66.2 363.4 0 256 0zm0 416c56.7 0 96.1-35.4 118.6-67.4l-13.1-9.2C340.6 369.2 305.4 400 256 400s-84.6-30.8-105.4-60.6l-13.1 9.2c22.4 32 61.9 67.4 118.6 67.4zM192.4 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceGlasses = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;